import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { MailIcon, PhoneIcon, MapPinIcon, SendIcon } from 'lucide-react';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-953">
      <Navbar data-id="element-954" />
      <main className="flex-1" data-id="element-955">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-956">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-957">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-958">
              Contact Us
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-959">
              We're here to help. Get in touch with our team for support,
              inquiries, or feedback.
            </p>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-960">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-961">
            {/* Contact Info */}
            <div className="space-y-8" data-id="element-962">
              <div data-id="element-963">
                <h2 className="text-2xl font-bold text-text-dark mb-4" data-id="element-964">
                  Get in Touch
                </h2>
                <p className="text-text-muted leading-relaxed" data-id="element-965">
                  Whether you're a facility looking to fill shifts or a
                  healthcare professional seeking opportunities, our team is
                  ready to assist you.
                </p>
              </div>

              <div className="space-y-6" data-id="element-966">
                <div className="flex items-start gap-4" data-id="element-967">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-968">
                    <PhoneIcon className="w-6 h-6 text-medical-blue" data-id="element-969" />
                  </div>
                  <div data-id="element-970">
                    <h3 className="font-bold text-text-dark" data-id="element-971">Phone</h3>
                    <p className="text-text-muted mt-1" data-id="element-972">1-800-555-1234</p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-973">
                      Available 24/7 for urgent staffing needs
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-974">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-975">
                    <MailIcon className="w-6 h-6 text-medical-blue" data-id="element-976" />
                  </div>
                  <div data-id="element-977">
                    <h3 className="font-bold text-text-dark" data-id="element-978">Email</h3>
                    <p className="text-text-muted mt-1" data-id="element-979">
                      support@carenomad.com
                    </p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-980">
                      We typically respond within 2 hours
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-981">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-982">
                    <MapPinIcon className="w-6 h-6 text-medical-blue" data-id="element-983" />
                  </div>
                  <div data-id="element-984">
                    <h3 className="font-bold text-text-dark" data-id="element-985">Headquarters</h3>
                    <p className="text-text-muted mt-1" data-id="element-986">
                      123 Healthcare Ave, Suite 400
                    </p>
                    <p className="text-text-muted" data-id="element-987">Toronto, ON M5V 3A8</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-float border border-gray-100 p-8" data-id="element-988">
              <h3 className="text-xl font-bold text-text-dark mb-6" data-id="element-989">
                Send us a message
              </h3>

              {submitted ? <div className="bg-soft-teal rounded-xl p-8 text-center" data-id="element-990">
                  <div className="w-16 h-16 bg-accent-teal rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-991">
                    <SendIcon className="w-8 h-8 text-white" data-id="element-992" />
                  </div>
                  <h4 className="text-xl font-bold text-text-dark mb-2" data-id="element-993">
                    Message Sent!
                  </h4>
                  <p className="text-text-muted" data-id="element-994">
                    Thank you for reaching out. A member of our team will get
                    back to you shortly.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="mt-6 text-medical-blue font-semibold hover:underline" data-id="element-995">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-996">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-997">
                    <div data-id="element-998">
                      <label htmlFor="firstName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-999">
                        First Name
                      </label>
                      <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Jane" data-id="element-1000" />
                    </div>
                    <div data-id="element-1001">
                      <label htmlFor="lastName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1002">
                        Last Name
                      </label>
                      <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Doe" data-id="element-1003" />
                    </div>
                  </div>

                  <div data-id="element-1004">
                    <label htmlFor="email" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1005">
                      Email Address
                    </label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="jane@example.com" data-id="element-1006" />
                  </div>

                  <div data-id="element-1007">
                    <label htmlFor="subject" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1008">
                      Subject
                    </label>
                    <select id="subject" className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors bg-white" data-id="element-1009">
                      <option data-id="element-1010">I'm a facility looking for staff</option>
                      <option data-id="element-1011">
                        I'm a healthcare worker looking for shifts
                      </option>
                      <option data-id="element-1012">General Inquiry</option>
                      <option data-id="element-1013">Support</option>
                    </select>
                  </div>

                  <div data-id="element-1014">
                    <label htmlFor="message" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-1015">
                      Message
                    </label>
                    <textarea id="message" rows={4} required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors resize-none" placeholder="How can we help you?" data-id="element-1016"></textarea>
                  </div>

                  <button type="submit" className="w-full bg-medical-blue hover:bg-medical-blue-dark text-white font-bold py-3.5 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-1017">
                    <SendIcon className="w-4 h-4" data-id="element-1018" />
                    Send Message
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </main>
      <StickyFooter data-id="element-1019" />
    </div>;
}